<template>
  <div class="maximum-mortgage">
    <div class="panel panel-default panel-stretch">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Geldverstrekkers</label>
              <div>
                <a-select mode="multiple" allowClear style="width: 100%" v-model="hdnCompanyCodes.value"
                          placeholder="Alle geldverstrekkers" :filterOption="this.filterSearch">
                  <a-select-option v-for="(option, key) in hdnCompanyCodes.values" :title="option" :key="key">
                    {{ option }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Aflossingsvorm</label>
              <div>
                <a-select mode="multiple" allowClear style="width: 100%" v-model="repaymentMethods.value"
                          :filterOption="this.filterSearch">
                  <a-select-option v-for="(option, key) in repaymentMethods.values" :key="key" :title="option"
                                   :value="key">
                    {{ option }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Hoofdsom ({{ (ltv.value * 100).toFixed(2) }}%)</label>
              <a-input class="number"
                       v-model="principalSum.value"
                       addon-before="€"
                       placeholder="200000"
                       :max-length="25"
                       @change="this.calculateLtv"
                       @blur="calculateLtv"
              />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Marktwaarde</label>
              <a-input class="number"
                       v-model="marketValue.value"
                       addon-before="€"
                       placeholder="200000"
                       :max-length="25"
                       @change="calculateLtv"
                       @blur="calculateLtv"
              />
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Type bouw</label>
              <div>
                <a-select allowClear style="width: 100%" v-model="buildingType.value">
                  <a-select-option v-for="(option, key) in buildingType.values" :key="key">
                    {{ option }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Rentekortingen</label>
              <div>
                <a-select mode="multiple" allowClear style="width: 100%" v-model="interestModifiers.value"
                          :filterOption="this.filterSearch">
                  <a-select-option v-for="(option, key) in interestModifiers.values" :title="option" :key="key">
                    {{ option }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Regeling</label>
              <div>
                <a-select allowClear style="width: 100%" v-model="productProvisioningStatus.value">
                  <a-select-option v-for="(option, key) in productProvisioningStatus.values" :key="key">
                    {{ option }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">NHG</label>
              <div>
                <a-radio-group default-value="a" button-style="solid" v-model="nationalMortgageGaruanteeType.value">
                  <a-radio-button v-for="(value, key) in nationalMortgageGaruanteeType.values" :value="key" :key="key">
                    {{ value }}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pull-right">
            <a-button type="primary" :loading="results.loading" @click="getResultsOverview">Haal rentes op</a-button>
          </div>
        </div>

      </div>
    </div>
    <div class="panel panel-default panel-stretch">
      <div class="panel-heading">Hypotheekrentes</div>
      <div class="panel-body no-padding">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th :class="{ columnSelected: results.sorting.enabled && results.sorting.type === 'lender'}"
                  @click="setSorting(null, 'lender', 'asc')">
                Geldverstrekker
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ columnSelected: results.sorting.enabled && results.sorting.type === 'name' }"
                  @click="setSorting(null, 'name', 'asc')">
                Productnaam
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 12 }"
                  @click="setSorting(12, 'rate', 'asc')">
                1 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 60 }"
                  @click="setSorting(60, 'rate', 'asc')">
                5 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 120 }"
                  @click="setSorting(120, 'rate', 'asc')">
                10 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 180 }"
                  @click="setSorting(180, 'rate', 'asc')">
                15 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 240 }"
                  @click="setSorting(240, 'rate', 'asc')">
                20 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 300 }"
                  @click="setSorting(300, 'rate', 'asc')">
                25 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
              <th :class="{ rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 360 }"
                  @click="setSorting(360, 'rate', 'asc')">
                30 jaar
                <i class="mdi mdi-chevron-down"></i>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="product in this.sortedOverviewResult" :class="{rowSelected: productIsSelected(product) }"
                @click="selectProduct(product)">
              <td :class="{ columnSelected: results.sorting.enabled && results.sorting.type === 'lender'}">
                {{ product.lender }} ({{ product.hdnMaatschappijType }})
              </td>
              <td :class="{ columnSelected: results.sorting.enabled && results.sorting.type === 'name' }">
                {{ product.name }} ({{ product.productName }})
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 12 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 12) }}</span>
                  </template>
                  {{ formatPercentage(product, 12) }}
                </a-tooltip>
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 60 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 60) }}</span>
                  </template>
                  {{ formatPercentage(product, 60) }}
                </a-tooltip>
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 120 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 120) }}</span>
                  </template>
                  {{ formatPercentage(product, 120) }}
                </a-tooltip>
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 180 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 180) }}</span>
                  </template>
                  {{ formatPercentage(product, 180) }}
                </a-tooltip>
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 240 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 240) }}</span>
                  </template>
                  {{ formatPercentage(product, 240) }}
                </a-tooltip>
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 300 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 300) }}</span>
                  </template>
                  {{ formatPercentage(product, 300) }}
                </a-tooltip>
              </td>
              <td :class="{  rate:true, columnSelected: results.sorting.enabled && results.sorting.type === 'rate' && results.sorting.rate === 360 }">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Rente vanaf: {{ formatStartingDate(product, 360) }}</span>
                  </template>
                  {{ formatPercentage(product, 360) }}
                </a-tooltip>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <MINTProductDetailsModalComponent
        v-if="showDetailModal && selectedProduct !== null"
        :product="selectedProduct"
        :key="selectedProduct.uniqueKey"
        :search-params="searchProductParams"
        v-on:close="onProductModalClose"
    ></MINTProductDetailsModalComponent>
  </div>
</template>

<script>
import {Skeleton} from "vue-loading-skeleton";
import mintApi from '~/api/mint';
import {get} from 'lodash';
import moment from 'moment';
import MINTProductDetailsModalComponent from "./ProductDetailsModalComponent";

export default {
  name: "MINTInterestRatePageComponent",
  components: {MINTProductDetailsModalComponent, Skeleton},
  props: {},
  data() {
    return {
      results: {
        loading: false,
        overview: [],
        sorting: {
          enabled: true,
          type: 'rate',
          direction: 'asc',
          rate: 240
        }
      },
      selectedProducts: {
        values: []
      },
      selectedProduct: null,
      nationalMortgageGaruanteeType: {
        value: [],
        values: []
      },
      productProvisioningStatus: {
        value: [],
        values: []
      },
      buildingType: {
        value: null,
        values: []
      },
      hdnCompanyCodes: {
        value: [],
        values: []
      },
      hdnCompanyProductCodes: {
        value: [],
        values: []
      },
      repaymentMethods: {
        value: [],
        values: []
      },
      interestModifiers: {
        value: [],
        values: []
      },
      marketValue: {
        value: 200000,
      },
      principalSum: {
        value: 200000,
      },
      ltv: {
        value: 1
      },
      noCache: false,
      loading: true,
      showDetailModal: false
    }
  },
  computed: {
    filtersEnabled: function () {
      return (this.hdnCompanyCodes.value.length > 0);
    },
    sortedOverviewResult: function () {
      if ( !this.results.overview ) return;

      var results = Object.values(this.results.overview);
      if (this.filtersEnabled) {
        results = results.filter((a) => {
          return this.hdnCompanyCodes.value.length > 0 && Object.values(this.hdnCompanyCodes.value).includes(a.hdnMaatschappijType);
        });
      }

      if (this.results.sorting.enabled === true) {

        if (this.results.sorting.type === 'lender') {
          results = results.sort(this.dynamicSort("lender"));
        }

        if (this.results.sorting.type === 'name') {
          results = results.sort(this.dynamicSort("name"));
        }

        if (this.results.sorting.type === 'rate')
          results = results.sort((a, b) => {
            var av = this.lodash.get(a, 'interestRates.' + this.results.sorting.rate + '.rate', null);
            var bv = this.lodash.get(b, 'interestRates.' + this.results.sorting.rate + '.rate', null);

            if (av === null) {
              return this.results.sorting.direction === 'asc' ? 1 : -1;
            }

            if (bv === null) {
              return this.results.sorting.direction === 'asc' ? -1 : 1;
            }

            if (av < bv) {
              return this.results.sorting.direction === 'asc' ? -1 : 1;
            }
            if (av > bv) {
              return this.results.sorting.direction === 'asc' ? 1 : -1;
            }

            return 0;
          });
      }

      return results;
    },
    searchProductParams: function () {
      return {
        repaymentMethods: this.repaymentMethods.value.length === 0 ? null : this.repaymentMethods.value,
        buildingType: this.buildingType.value,
        interestModifiers: this.interestModifiers.value
      }
    }
  },
  methods: {
    calculateLtv() {
      this.ltv.value = this.principalSum.value / this.marketValue.value;
    },
    selectProduct(product) {
      var index = this.selectedProducts.values.indexOf(product.uniqueKey);

      if (index === -1) {
        this.selectedProducts.values.push(product.uniqueKey);
      } else {
        Vue.set(this.selectedProducts.values, this.selectedProducts.values.splice(index, 1));
      }

      this.selectedProduct = product;
      this.showDetailModal = true;
      this.$emit('product-selected', product);
    },
    productIsSelected(product) {
      return false;
      // return this.selectedProducts.values.indexOf(product.uniqueKey) >= 0;
    },
    setSorting(rate, type, order) {
      this.results.sorting.type = type;
      this.results.sorting.direction = order;
      this.results.sorting.rate = rate;
    },
    getResultsOverview() {
      this.results.loading = true;
      return mintApi.interstRates({
        'no-cache': this.noCache,
        search: true,
        output: 'overview',
        ...this.getSearchParams()
      }).then((response) => {
        this.results.overview = response.data;
      }).finally(() => {
        this.results.loading = false;
      });
    },
    get: get,
    getSearchParams() {
      return {
        nationalMortgageGaruanteeType: this.nationalMortgageGaruanteeType.value,
        repaymentMethods: this.repaymentMethods.value.length === 0 ? null : this.repaymentMethods.value,
        buildingType: this.buildingType.value,
        hdnCompanyCodes: this.hdnCompanyCodes.value.length === 0 ? null : this.hdnCompanyCodes.value,
        loanToValues: [this.ltv.value],
        interestModifiers: this.interestModifiers.value
      }
    },
    formatPercentage(product, rate) {
      var value = this.lodash.get(product, 'interestRates.' + rate + '.rate', null)

      if (value == null) {
        return '-';
      }

      return this.lodash.round((value * 100), 6).toFixed(2) + '%';

    },
    formatStartingDate(product, rate) {
      var value = this.lodash.get(product, 'interestRates.' + rate + '.startingDate', null)

      if (value == null) {
        return 'onbekend';
      }

      return moment(value).format('DD-MM-YYYY')

    },
    dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {

        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result = ((a[property].toLowerCase()) < (b[property].toLowerCase())) ? -1 : ((a[property].toLowerCase()) > (b[property].toLowerCase())) ? 1 : 0;
        return result * sortOrder;
      }
    },
    filterSearch(input, option) {
      return option.componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
          || option.data.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onProductModalClose() {
      this.selectedProduct = null;
      this.showDetailModal = false;
    }
  },
  async mounted() {
    mintApi.interstRates({
      search: false,
    }).then((response) => {
      //Set meta fields
      this.nationalMortgageGaruanteeType.values = response.meta.nationalMortgageGaruanteeType.values;
      this.nationalMortgageGaruanteeType.value = response.meta.nationalMortgageGaruanteeType.default;

      this.productProvisioningStatus.values = response.meta.productProvisioningStatus.values;
      this.productProvisioningStatus.value = response.meta.productProvisioningStatus.default;

      this.buildingType.values = response.meta.buildingType.values;
      this.buildingType.value = response.meta.buildingType.default;

      this.hdnCompanyCodes.values = response.meta.hdnCompanyCodes.values;

      this.repaymentMethods.values = response.meta.repaymentMethods.values;
      this.repaymentMethods.value = response.meta.repaymentMethods.default;

      this.interestModifiers.values = response.meta.interestModifiers.values;
      this.interestModifiers.value = response.meta.interestModifiers.default;

      this.getResultsOverview();
      this.noCache = true;
    })
  }
}
</script>

<style scoped>
table .columnSelected {
  background-color: #0d2535 !important;
  color: white;
}

table tr.rowSelected > td.columnSelected {
  background-color: cornflowerblue;
  font-width: bold;
}

table td.rate, th.rate {
  text-align: center;
}

table tr {
  cursor: pointer;
}

table tr:hover td {
  background-color: #f2f6ff;
}

table tr.rowSelected {
  background-color: lightyellow !important;
}

.ant-input {
  text-align: center;
}
</style>
